export { default } from './PatientReviews';
